import { OfferFragment, Store_Location_Evaluation_Method } from '@occc/graphql';

import { useGetStoreLocationConstraint } from './use-get-store-location-constraint.hook';

import { StoreLocationOrGroupsFormValues } from '../store-location-or-groups.types';
import { getStoreLocationGroupConstraint } from '../store-location-or-groups.utils';

const STORE_LOCATION_EVALUATION_METHOD: Store_Location_Evaluation_Method =
  Store_Location_Evaluation_Method.Include;

export const useGetStoreLocationOrGroupsInitialValues = (
  offer: OfferFragment | null | undefined,
): StoreLocationOrGroupsFormValues => {
  const storeLocationConstraint = useGetStoreLocationConstraint(offer);

  if (!offer) {
    return {
      storeLocationOrGroups: {
        storeLocation: {
          evaluationMethod: STORE_LOCATION_EVALUATION_METHOD,
        },
        storeLocationGroup: {},
        type: 'storeLocation',
      },
    };
  }

  const storeLocationGroupConstraint = getStoreLocationGroupConstraint(offer.constraints);

  if (storeLocationConstraint || storeLocationGroupConstraint) {
    return {
      storeLocationOrGroups: {
        storeLocation: {
          id: storeLocationConstraint?.id,
          locations: storeLocationConstraint?.locations,
          evaluationMethod:
            storeLocationConstraint?.evaluationMethod ?? STORE_LOCATION_EVALUATION_METHOD,
        },
        storeLocationGroup: {
          id: storeLocationGroupConstraint?.id,
          locationGroups: storeLocationGroupConstraint?.locationGroups ?? [],
        },
        type: storeLocationGroupConstraint ? 'storeLocationGroups' : 'storeLocation',
      },
    };
  }

  return {
    storeLocationOrGroups: {
      storeLocation: {
        evaluationMethod: STORE_LOCATION_EVALUATION_METHOD,
      },
      storeLocationGroup: {},
      type: 'storeLocation',
    },
  };
};
